import React from "react";
import { Stores } from "Globals/Stores";
import { Button, Table, TableHead, TableBody, TableRow, TableContainer, TableCell } from "@material-ui/core";
import { BinSVG } from "Globals/Views/IconSVGs/BinSVG";

// App
import PropertyDetailsViewModel from "Globals/ViewModels/FormSections/PropertyDetails/PropertyDetailsViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import PersonViewModel from "Globals/ViewModels/Shared/PersonViewModel";

interface IProps {
    personViewModels: PersonViewModel[];
    propertyDetailsViewModel: PropertyDetailsViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
    storesContext: Stores;
}

export const PersonTable: React.FC<IProps> = ({ personViewModels, propertyDetailsViewModel, applicationFormViewModel, storesContext }) => {
    const isDeleteDisabled = applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving;

    return (
        <TableContainer>
            <Table style={{ width: "100%" }} aria-label="person table">
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align="center">Gender</TableCell>
                        <TableCell align="center">Date of birth</TableCell>
                        <TableCell align="center">Relationship to you</TableCell>
                        <TableCell align="left">Why this person is not included in the purchase of the property</TableCell>
                        <TableCell align="center">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {personViewModels.map((person) => (
                        <PersonTableRow
                            key={person.model.id}
                            person={person}
                            propertyDetailsViewModel={propertyDetailsViewModel}
                            isDeleteDisabled={isDeleteDisabled}
                            storesContext={storesContext}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

interface IRowProps {
    person: PersonViewModel;
    propertyDetailsViewModel: PropertyDetailsViewModel;
    isDeleteDisabled: boolean;
    storesContext: Stores;
}

const PersonTableRow: React.FC<IRowProps> = ({ person, propertyDetailsViewModel, isDeleteDisabled, storesContext }) => (
    <TableRow key={person.model.id}>
        <TableCell component="th" scope="row">
            {person.model.name}
        </TableCell>
        <TableCell align="center">{person.genderDisplayName}</TableCell>
        <TableCell align="center">{person.getFormattedDateOfBirth}</TableCell>
        <TableCell align="center">{person.relationshipDisplayName}</TableCell>
        <TableCell align="left">{person.model.notes}</TableCell>
        <TableCell align="center">
            {!isDeleteDisabled && (
                <Button onClick={() => person.delete(propertyDetailsViewModel)}>
                    <BinSVG />
                </Button>
            )}
        </TableCell>
    </TableRow>
);
